import React from 'react';
import cn from 'classnames';
import { generatePath, useHistory } from 'react-router';

import { IModel } from 'models/company/interface';

import { setPopup } from 'client/redux/ui';
import { imgixUrl } from 'client/utils/imgix-url';
import { selectLang } from 'client/redux/settings/selectors';
import { useAppDispatch, useAppSelector } from 'client/hooks';
import { COMPANY_TEAM_MEMBER_PAGE_ROUTE } from 'client/constants/routes';

import defaultMemberPhoto from 'client/assets/default-avatar.svg';

import css from './Founder.module.scss';

interface Props {
  personInfo: IModel['team'][number];
  companyId: string;
  className?: string;
}

const IMGIX_PARAMS = {
  'max-w': 200,
  fit: 'fill',
  auto: 'compress',
  q: 85,
};

const Founder = ({ personInfo, companyId, className = '' }: Props) => {
  const history = useHistory();
  const lang = useAppSelector(selectLang);
  const dispatch = useAppDispatch();

  const onPersonClick = () => {
    history.push(generatePath(COMPANY_TEAM_MEMBER_PAGE_ROUTE, { id: companyId, slug: personInfo.slug, lang }));
    dispatch(setPopup(null));
  };

  return (
    <div
      key={personInfo.name}
      className={cn(className, css.teamMemberInfo, personInfo.slug && css.link)}
      role={personInfo.slug ? 'link' : 'none'}
      onClick={personInfo.slug ? onPersonClick : undefined}
    >
      <div
        className={css.photo}
        style={{
          backgroundImage: `url(${personInfo.avatar ? imgixUrl(personInfo.avatar, IMGIX_PARAMS) : defaultMemberPhoto})`,
        }}
      ></div>
      <div className={css.info}>
        <p className={css.name}>{personInfo.name}</p>
        <p className={css.position}>{personInfo.role}</p>
      </div>
    </div>
  );
};

export default Founder;
